import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { forwardRef, ReactElement, Ref, useEffect, useState } from "react";

import { TransitionProps } from "@mui/material/transitions";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from "react-router-dom";
import tabbg from "../../../assets/images/tab_01.png"
import useStressStore from "../../../store/stressStores";
import api from "../../../utils/api";

import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Paper from '@mui/material/Paper';


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];

// 모달창
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const Stress = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();

  useEffect(() => {
    getStressList();

    return () => {
      storeData.clear();
    }
  }, [])

  // 모달창
  const [open, setOpen] = useState(false);
  const handleOpen = (submitted: any, info: any, survey: any) => {
    storeData.setTargetInfo(info);
    storeData.setTargetSurvey(survey);

    if (!submitted) setTimeout(() => setOpen(true), 100)
    else navigate('result', { state: { assigned_uid: info.uid } })
  };
  const handleClose = () => {
    setOpen(false);
  }

  function getStressList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}`)
    .then(res => {
      // console.log(res);
      res.data.data.sort((a: any, b: any) => b.info.year - a.info.year);
      storeData.setStressList(res.data.data);
    })
    .catch(err => {
      console.log(err);
    });
  }

  function targetLow(info: any, survey: any) {
    storeData.modalClear();
  }

  function handleStressMain() {
    let famId: any = localStorage.getItem('ownerFamID');
    // navigate(`main?famId=${encodeURIComponent(famId)}&assigned_uid=${storeData.targetInfo.uid}&survey_uid=${storeData.targetSurvey.uid}`)

    const items = {
      famId: famId,
      assigned_uid: storeData.targetInfo.uid,
      survey_uid: storeData.targetSurvey.uid,
    }

    navigate('main', { state: items })
  }

  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '2rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
              한국인 직무 스트레스 측정도구<br/>(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
      
      <Grid item>
        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center', mb: 2 }}>
        제출 된 응답은 수정이 <b>불가능</b>합니다.
        </Typography>
      </Grid>

      <TableContainer sx={{p: 2, boxSizing:'border-box',}}>
        <Paper sx={{ borderRadius: 5}}>
          <Table size="small" className="Cl_table" sx={{width: '100%', ml: 'auto', mr: 'auto', bgcolor :'#fff',borderRadius: 5}}>
            <TableHead>
              <TableRow sx={{'& th' :{p: 2, textAlign: 'center'}}}>
                <TableCell>연도</TableCell>
                <TableCell>제목</TableCell>
                <TableCell>참여</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{'& td' :{px:1, py:2, textAlign: 'center',}, '& tr:last-child td' :{borderBottom: '0px', }}}>
              {
                storeData.stressList.length == 0
                  ? <TableRow>
                    <TableCell colSpan={3}>해당하는 설문이 없습니다.</TableCell>
                  </TableRow>
                  : storeData.stressList && storeData.stressList.map((item: any, idx: number) => {
                    return (
                      <TableRow key={idx} onClick={() => { handleOpen(item.is_submitted, item.info, item.info.survey); }}>
                        <TableCell sx={{width: 50}}>{item.info.year}</TableCell>
                        <TableCell>{item.info.survey.title}</TableCell>
                        <TableCell>
                          {
                            item.is_submitted
                              ? <Typography sx={{width: 80, background: '#999',textAlign: 'center', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14, border:'1px solid #999'}}>완료</Typography>
                              : <Typography sx={{width: 80, background: '#fff', textAlign: 'center', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#0087ff', fontSize: 14, border:'1px solid #0087ff'}}>대기</Typography>
                          }
                        </TableCell>
                      </TableRow>
                    )
                  })
              }
            </TableBody>
          </Table>
        </Paper>
      </TableContainer>

      {/* 모달창 */}
      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}

        >
          <DialogContent >
            <Container>
              <Box sx={{ textAlign: 'center' }}>
                <ErrorOutlineIcon sx={{fontSize: 36, color: '#db0000', mb : 3}}/>
                <Box>
                  <Typography>{`[${storeData.targetInfo.year}년도 ${storeData.targetSurvey.title}]`}</Typography>
                  <Typography>완료가 필요합니다.</Typography>
                </Box>
              </Box>
            </Container>
          </DialogContent>

          <DialogActions>
            <Box sx={{alignItems: 'center'}}>
              <Button onClick={() => handleStressMain()} sx={{bgcolor: '#EF8322', color: '#fff', '&:hover' : {bgcolor: '#EF8322'}}}>확인</Button>
              {/* ${location.origin}/${view}/survey/stress/main?famId=${encodeURIComponent(familyId)}&assigned_uid=${assignedId}&survey_uid=${surveyUid} */}
              <Button onClick={handleClose}  sx={{bgcolor: '#ccc', color: '#888', ml: 1,'&:hover' : {bgcolor: '#aaa', color: '#333'}}}>닫기</Button>
            </Box>
          </DialogActions>
        </Dialog>
      }

      <Bottom />
    </Container>
  )
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


export default Stress;